<section
  class="global-alert-stack"
  [class.configuration-offset]="hasConfigurationOffset"
  aria-label="Page alerts"
  aria-live="assertive"
  aria-relevant="additions removals"
>
  <article
    *ngFor="let alert of visibleAlerts$ | async; trackBy: trackAlert"
    class="global-alert shadow"
    [class.global-alert-danger]="alert.severity === 'danger'"
    [class.global-alert-warning]="alert.severity === 'warning'"
    [class.global-alert-info]="alert.severity === 'info'"
    [class.global-alert-success]="alert.severity === 'success'"
    [class.is-closing]="alert.closing"
    role="alert"
  >
    <div class="global-alert-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 9v4" />
        <path d="M12 17v.01" />
        <path d="M10.36 3.591l-8.16 14a2 2 0 0 0 1.73 3h16.14a2 2 0 0 0 1.73 -3l-8.16 -14a2 2 0 0 0 -3.28 0z" />
      </svg>
    </div>
    <div class="global-alert-copy">
      <div class="global-alert-title">{{ severityLabel(alert) }}</div>
      <div class="global-alert-message">{{ alert.message }}</div>
    </div>
    <button
      *ngIf="alert.dismissible"
      type="button"
      class="global-alert-dismiss"
      [attr.aria-label]="'Dismiss ' + severityLabel(alert).toLowerCase() + ' alert'"
      (click)="alertService.dismiss(alert.id)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M18 6l-12 12" />
        <path d="M6 6l12 12" />
      </svg>
    </button>
  </article>
</section>
